export default __webpack_public_path__ + "static/media/obslogo.4233f78a.svg";